import { icons, svgIcons } from "@tools";
import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgFilter({
    token: Token.IconFilter,
    dependencies: [
        Token.$Sce
    ]
})
export class IconFilter {
    constructor(
        private $sce: ng.ISCEService
    ) {
        return ((key: string) => {
            if (key) key = key.toCamelCase();
            let icon = icons[key];
            if (!icon) {
                icon = svgIcons[key];
                if (icon) {
                    return this.$sce.trustAsHtml(icon);
                }
            }
            if (!icon) {
                icon = key;
            }
            return icon;
        }) as any;
    }
}
